export enum ReportingAccessLevels {
    NONE = 'None',
    BLF = 'Akixi BLF',
    ONE = 'Akixi ONE',
    ESSENTIALS = 'Essentials',
    CXA_STANDARD = 'CXA Standard',
    PROFESSIONAL = 'Professional',
    CXA_PREMIUM = 'CXA Premium',
    ENTERPRISE = 'Enterprise',
    CXA_ADVANCED = 'CXA Advanced',
    CXA_ADVANCED_HISTORICAL = 'CXA Advanced (Historic)',
    CALL_CENTRE_AGENT = 'Call Centre Agent',
    CXE_PREMIUM = 'CXE Premium',
    CALL_CENTRE_SUPERVISOR = 'Call Centre Supervisor',
    CXE_ADVANCED = 'CXE Advanced',
    LITE = 'Akixi Lite',
    ONE_THOUSAND = 'Akixi 1000',
    TWO_THOUSAND = 'Akixi 2000',
    WXC_USER = 'WxC User',
    WXC_AGENT = 'WxC Agent',
    WXC_SUPERVISOR = 'WxC Supervisor'
}

export const RESTRICTED_LEVELS: ReportingAccessLevels[] = [
    ReportingAccessLevels.ESSENTIALS,
    ReportingAccessLevels.PROFESSIONAL,
    ReportingAccessLevels.CALL_CENTRE_AGENT
]
